import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {AbstractFilter} from './AbstractFilter';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export class MatrixFilter extends AbstractFilter {
    protected _matrix: number[][];

    constructor(name: string, matrix: number[][]) {
        super(name);

        this._matrix = matrix;
    }

    public filter(response: Message): boolean {
        const action = response.getAction();

        if (action !== Action.SPIN && action !== Action.FREESPIN && action !== Action.RESPIN &&
            // @ts-ignore TODO: refactoring required!
            action !== Action.MINISPIN
        ) {
            return true;
        }

        const symbolIds = this.getSpin(response).symbolIds;

        for (let i = 0; i < symbolIds.length; i++) {
            for (let j = 0; j < symbolIds[i].length; j++) {
                if (symbolIds[i][j] === this._matrix[i][j] || this._matrix[i][j] === undefined) {
                    continue;
                } else {
                    return false;
                }
            }
        }

        return true;
    }
}
